<template>
  <div class="row">
    <div class="col-12 col-md-12">
      <div class="modal-info-header">
        <h3>{{ shortenName(moreInfo.product_name, airport.airport_name) }}</h3>
        <p v-if="moreInfo.product_type == 'airportparking' && moreInfo.park_type !== 'Chauffeur'" v-html="formatAddress(moreInfo.customer_address)"></p>
        <p v-if="moreInfo.product_type == 'airportlounge'" class="number"><i class="icon-bus"></i>{{ $t('airportlounge.results.terminal') }} {{ moreInfo.terminal }}</p>
        <p v-if="moreInfo.product_type == 'airporthotel'" class="number hotel-room"><i class="icon-bed mr-2"></i>1 x {{ moreInfo.rooms[0].room_type.value }} {{ $t('airporthotel.results.room') }}</p>
        <button class="btn close more-info-close" @click="moreInfo = false">&times;</button>
      </div>
    </div>
  </div>
</template>

<script>
import { sync, get } from "vuex-pathify";
import mixins from "@/mixins";

export default {
  name: "modal-header",
  mixins: [mixins.format],
  computed: {
    moreInfo: sync("modals/moreInfo"),
    airport: get("results/airport")
  },
  methods: {
    formatAddress(address) {
      return address.replace(/[<]br[^>]*[>]/gi,',').replace(/,\s*$/, '')
    }
  }
};
</script>